export const flgStatusOptions = [
    {
        value: true,
        label: 'Ativo'
    },
    {
        value: false,
        label: 'Inativo'
    },
];